import { bl_fi_internal_sales_cash_bill_import_file_hdr_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class CashBillFileImportContainerModel extends BaseContainerModel {
    bl_fi_internal_sales_cash_bill_import_file_hdr: bl_fi_internal_sales_cash_bill_import_file_hdr_RowClass = new bl_fi_internal_sales_cash_bill_import_file_hdr_RowClass();
}
